//Discount calculation
export function getPriceWithDiscount({ basePrice, discount, nights }) {
  if (discount > 0) {
    let singleNightDiscount = discount / nights;
    basePrice = basePrice - singleNightDiscount;
  }
  return basePrice;
}

export function getFixedValue(value) {
  if (!value) return value;
  return Number((Math.round(value * 100) / 100).toFixed(2));
}

export function cancellationGuestData(
  remainingNights,
  nights,
  priceForDays,
  accomodation,
  isCleaingPrice,
  taxRate,
  guestServiceFee,
  guestFees,
  discount,
  hostServiceFee,
  taxPrice,
  basePrice, // Either special price average or base price from reserveration with discount is set
  total,
  policyName,
  interval,
  priorDays,
  nonRefunableNights,
  hostServiceFeeType,
  hostServiceFeeValue,
  currency,
  base,
  rates,
  serviceFees,
  cleaningFeePercent,
  taxFeePercent,
  isPetFee
) {

  let refundableNightPrice = 0, nonRefundableNightPrice = 0, refundWithoutGuestFee = 0, updatedHostFee = 0, payoutToHost = 0;
  let checkInNights = (remainingNights == 0 || remainingNights > 0) ? remainingNights : nights, hostRefund = 0;
  let totalNights = checkInNights - nonRefunableNights, isTaxPrice, hostRefundFee;

  //Check nonRefunableNights if greater than checkInNights
  totalNights = totalNights > 0 ? totalNights : 0;
  //Based on the policy, update the guest fee
  let updatedGuestFee = (guestServiceFee * (guestFees / 100)), //This variable stores refunded guest fee value.
    paidAmount = total + guestServiceFee;

  //Based on the policy, update the cleaning price & taxPrice
  isCleaingPrice = (isCleaingPrice * (cleaningFeePercent / 100));

  //Based on the policy, update the pet fee
  isPetFee = (isPetFee * (cleaningFeePercent / 100));


  isTaxPrice = (taxPrice * (taxFeePercent / 100));

  //Refund amount without considering guest service fee
  refundableNightPrice = getFixedValue(((totalNights * basePrice) * (accomodation / 100)) + isCleaingPrice + isTaxPrice + isPetFee);

  //Host Payout amount without subtracting host service fee. total has cleaning Fee & tax with in it.
  hostRefund = getFixedValue(total - refundableNightPrice);

  //Adding guest service fee, if it could be refunded
  refundableNightPrice = refundableNightPrice + updatedGuestFee;

  //calculate hostservicefee without tax
  hostRefundFee = isTaxPrice === 0 ? hostRefund - taxPrice : hostRefund;

  //Payout amount calculated with host service fee
  if (hostRefund > 0) {
    updatedHostFee = getFixedValue(hostServiceFeeType === 'percentage' ? hostRefundFee * (Number(hostServiceFeeValue) / 100) : hostServiceFee);
    payoutToHost = getFixedValue(hostRefund - updatedHostFee);
  }

  //Non refundable amount calculated based on the total amount guest paid and the refundable amount with guest service fee
  nonRefundableNightPrice = getFixedValue(paidAmount - refundableNightPrice);

  return {
    refundableNightPrice,
    refundWithoutGuestFee,
    nonRefundableNightPrice,
    //If this updatedGuestFee with in object is 0, admin won't get guest service fee after cancellation
    updatedGuestFee: guestServiceFee - updatedGuestFee, //Either whole guest service is refunded or none based on the policy
    payoutToHost,
    updatedHostFee
  };
}

export function calculateHostCancellation({
  total,
  basePrice, // Either special price average or base price from reserveration with discount is set
  isCleaingPrice,
  nights,
  remainingNights,
  guestServiceFee, //Guest service fee value, when the reservation is created
  hostServiceFee, //Host service fee value, when the reservation is created
  taxPrice,
  hostServiceFeeType, //Host service fee set by admin at the time of creating reservation
  hostServiceFeeValue, //Host service fee type set by admin at the time of creating reservation
  interval,
  isPetFee,
  policyId
}) {

  let refundAmount = 0, nonPayoutAmount = 0, payoutAmount = 0, hostRefund = 0, refundDays = nights;
  let updatedHostFee = hostServiceFee, updatedGuestFee = guestServiceFee, hostRefundFee, taxAmount = taxPrice;

  //If the cancellation is done after or during check in date
  if (policyId != 3 &&  interval <= 0 && remainingNights < nights) {
    refundDays = remainingNights;
    isCleaingPrice = 0;
    guestServiceFee = 0;
    taxPrice = 0;
    isPetFee = 0;
  }

  //Refund amount to guest
  refundAmount = getFixedValue((refundDays * basePrice) + isCleaingPrice + taxPrice + isPetFee);

  //Host Payout amount without subtracting host service fee. total has cleaning Fee & tax with in it.
  hostRefund = getFixedValue(total - refundAmount);

  //calculate hostservicefee without tax
  hostRefundFee = taxPrice === 0 ? hostRefund - taxAmount : hostRefund;

  //Payout amount calculated with host service fee
  if (hostRefund > 0) {
    nonPayoutAmount = refundAmount; //guest service fee and cleaning fee won't be here
    //New host service fee calculated based on the host refund amount.
    updatedHostFee = getFixedValue(hostServiceFeeType === 'percentage' ? hostRefundFee * (Number(hostServiceFeeValue) / 100) : hostServiceFee);
    payoutAmount = getFixedValue(hostRefund - updatedHostFee);
  }
  else {
    //Payout amount of host is zero
    nonPayoutAmount = getFixedValue(total - updatedHostFee);
    updatedGuestFee = 0; //Guest fee refunded
    updatedHostFee = 0;
  }

  //Adding guest service fee, if it could be refunded
  refundAmount = refundAmount + guestServiceFee;

  return {
    refundAmount,
    nonPayoutAmount,
    payoutAmount,
    refundDays,
    updatedHostFee,
    updatedGuestFee //If this value is 0, admin won't get guest service fee after cancellation
  };
}